// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavBarItem_navItem__1vaSM","active":"NavBarItem_active__1zOPm"};